__turbopack_context__.v({
  "paymentBadge": "payment-badges-module__-CG58G__paymentBadge",
  "paymentBadges": "payment-badges-module__-CG58G__paymentBadges",
});
